import { isCustomizedType, reduce } from "et3-type-guards";
import { post } from "../axios-post";
import i18nServerResponse from "../../constants/i18n-server-response";
import { Ti18nKeys } from "../../constants/i18n";
import { TalkhattabatConversationType } from "../../Types";

export const apiCallSetOneOOneHighLight = async ({
  conversationID,
  newState,
  conversationType
}: {
  conversationID: string;
  newState: number;
  conversationType: TalkhattabatConversationType;
}): Promise<{
  data: {};
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{}>(
    `khattabat/setOneOOneHighlight`,
    {
      conversationID,
      newState,
      conversationType
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {},
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {},
      status: "ERROR",
      code: "ERROR"
    };
  }
};
